import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function PageNotFound({}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {}, []);

  return (
    <main
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div>
        <p>{t("pageNotFound.title")}</p>
        <div className="d-flex justify-content-between">
          <Button onClick={() => navigate("/")}>{t("common.home")}</Button>
          <Button onClick={() => navigate(-1)}>{t("common.back")}</Button>
        </div>
      </div>
    </main>
  );
}
